export enum Day {
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
  Sunday
}

export const dayList = [
  { value: Day.Monday, name: "Poniedziałek", shortName: "Pn", index: 1 },
  { value: Day.Tuesday, name: "Wtorek", shortName: "Wt", index: 2 },
  { value: Day.Wednesday, name: "Środa", shortName: "Śr", index: 3 },
  { value: Day.Thursday, name: "Czwartek", shortName: "Cz", index: 4 },
  { value: Day.Friday, name: "Piątek", shortName: "Pt", index: 5 },
  { value: Day.Saturday, name: "Sobota", shortName: "So", index: 6 },
  { value: Day.Sunday, name: "Niedziela", shortName: "Nd", index: 7 }
];
